import React, { Component } from 'react'
import PropTypes from 'prop-types'

import axios from 'axios'

import FavoriteIcon from '../icons/FavoriteIcon'
import CartIcon from '../icons/CartIcon'

import Breadcrumbs from './../block/Breadcrumbs'
import DeliveryMethods from './../block/DeliveryMethods'

import { Container, Image, Spinner, Button, Form, Modal } from 'react-bootstrap'

import { IMaskInput } from "react-imask"

import styles from './../style/Korzina.module.scss'
import icon_styles from './../style/InputIcons.module.scss'

export default class Oformlenie extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      products: [],
      count: 0,
      sortName: `Сначала дешевле`,
      payment: 0,
      delivery_method: 0,
      delivery_id: 0,
      delivery_adres: 0,
      delivery_price: 0,
      name: ``,
      phone: ``,
      email: ``,
      inn: ``,
      company: ``,
      comment: ``,
      show: false,
      modal_text: ``,
      isSubmitting: false,
      certificate: false,
      nalog: `usn`
    }
  }

  setName( val ) {
    this.setState({
      name: val
    })
  }
  setPhone( val ) {
    this.setState({
      phone: val
    })
  }
  setEmail( val ) {
    this.setState({
      email: val
    })
  }
  setComment( val ) {
    this.setState({
      comment: val
    })
  }

  change_inn( val ) {
    this.setState({
      inn: val
    })
  }
  change_company( val ) {
    this.setState({
      company: val
    })
  }

  setDelivery = ( dmet, id, adres, price ) => {
    this.setState({
      delivery_method: dmet,
      delivery_id: id,
      delivery_adres: adres,
      delivery_price: Number( price )
    })
  }

  formatPrice(price) {
    return this.priceFormat(price) + ' ₽'
  }

  priceFormat(price, delimiter = '', fraction = '') {
    if (!price && price !== 0) return 'Цена не указана'
    
    const numericPrice = typeof price === 'number' ? price : parseFloat(price)
    
    return numericPrice.toLocaleString('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  normalizeCountForm = (number, words_arr) => {
    number = Math.abs(number)
    if (Number.isInteger(number)) {
      let options = [2, 0, 1, 1, 1, 2]
      return words_arr[(number % 100 > 4 && number % 100 < 20) ? 2 : options[(number % 10 < 5) ? number % 10 : 5]]
    }
    return words_arr[1]
  }

  getCart() {
    const { cart, addTocart } = this.props

    const baseURL = window.location.protocol + "//" + window.location.hostname
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'get_cart_data',
      'cart': JSON.stringify( cart ),
      'loyality': 1
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      var fined = false
      cart.map( ( product ) => {
        fined = false
        response.data.products.map( ( in_cart ) => {
          if( product.variant == null ) {
            if( product.product == in_cart.product ) {
              if( in_cart.stocks < product.count ) {
                addTocart({
                  resource: product.resource,
                  product: product.product,
                  variant: null,
                  count: in_cart.stocks
                })
              }
              fined = true
            }
          } else {
            if( product.product == in_cart.product && product.variant == in_cart.variant ) {
              if( in_cart.stocks < product.count ) {
                addTocart({
                  resource: product.resource,
                  product: product.product,
                  variant: product.variant,
                  count: in_cart.stocks
                })
              }
              fined = true
            }
          }
        } )
        if( !fined ) {
          addTocart({
            resource: product.resource,
            product: product.product,
            variant: product.variant,
            count: 0
          })
        }
      } )
      this.setState({
        loaded: true,
        products: response.data.products,
        count: response.data.count,
        sum: response.data.sum,
        certificate: response.data?.certificate || false
      })
    })
  }

  changeCount = ( product, count ) => {
    const { addTocart } = this.props,
    main = this

    addTocart({
      resource: product.res_id,
      product: product.product,
      variant: product.variant,
      count: count
    }, () => {
      main.getCart()
    })
  }

  getPointPrice = ( code ) => {
    window.console.log( code )
  }

  setPayment( payment ) {
    this.setState({
      payment: payment
    })
  }

  sendOrder = () => {
    if (this.state.isSubmitting) return;

    const { name, phone, inn, company, email, comment, delivery_method, delivery_id, delivery_price, payment, nalog } = this.state,
    { cart, ajax_data, clearCart, user_profile_type } = this.props
    var { delivery_adres } = this.state

    // Валидация полей
    if( name == `` ) {
      this.setState({
        show: true,
        modal_text: `Укажите Ваше имя`
      })
      return
    }
    if( phone == `` ) {
      this.setState({
        show: true,
        modal_text: `Укажите Ваш телефон`
      })
      return
    }
    if( email == `` ) {
      this.setState({
        show: true,
        modal_text: `Укажите Ваш e-mail`
      })
      return
    }
    if( delivery_method == 0 ) {
      this.setState({
        show: true,
        modal_text: `Выберите способ доставки`
      })
      return
    }
    if( delivery_method == 5 ) {
      delivery_adres = 'Самовывоз'
    } else {
      if( delivery_adres.length < 3 ) {
        this.setState({
          show: true,
          modal_text: `Ошибка: некоректный адрес доставки`
        })
        return
      }
    }
    if( payment == 0 ) {
      this.setState({
        show: true,
        modal_text: `Выберите способ оплаты`
      })
      return
    }

    // Устанавливаем состояние отправки
    this.setState({ isSubmitting: true })

    const baseURL = window.location.protocol + "//" + window.location.hostname,
    main = this
    axios.post(`${baseURL}`, {
      'content_type': 'application/json',
      'action': 'send_order',
      'cart': JSON.stringify( cart ),
      'name': name,
      'phone': phone,
      'inn': inn,
      'company': company,
      'email': email,
      'delivery_method': delivery_method,
      'delivery_id': delivery_id,
      'delivery_adres': delivery_adres,
      'delivery_price': delivery_price,
      'payment': payment,
      'comment': comment,
      'profile_type': user_profile_type,
      'nalog': nalog
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then( ( response ) => {
      if( response.data.success ) {
        clearCart( () => {
          location.href = ajax_data.oformlen_link + `?msorder=` + response.data.data.msorder
        } )
      } else {
        if( 'message' in response.data ) {
          main.setState({
            show: true,
            modal_text: 'Ошибка: ' + response.data.message
          })
        } else {
          main.setState({
            show: true,
            modal_text: 'Ошибка оформления заказа, попробуйте позже!'
          })
        }
      }
    }).catch(error => {
      console.error('Error sending order:', error)
      this.setState({
        show: true,
        modal_text: 'Ошибка оформления заказа, попробуйте позже!'
      })
    }).finally(() => {
      // В любом случае снимаем состояние отправки
      this.setState({ isSubmitting: false })
    })
  }

  handleClose() {
    this.setState({
      show: false
    })
  }

  setNalog = ( val ) => {
    this.setState({
      nalog: val
    })
  }

  printOrder = () => {
    const { name, phone, email, inn, company, delivery_adres, delivery_price, nalog } = this.state;
    const { products, sum } = this.state;

    // Создаем содержимое для печати
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>Заказ StomaHelp</title>
        <meta charset="utf-8">
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          .print-header { text-align: center; margin-bottom: 20px; }
          .print-section { margin-bottom: 15px; }
          .print-section h3 { margin-bottom: 5px; color: #333; }
          .print-table { width: 100%; border-collapse: collapse; margin: 15px 0; }
          .print-table th, .print-table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
          .print-table th { background-color: #f5f5f5; }
          .print-total { font-weight: bold; margin-top: 10px; }
          @media print {
            body { margin: 0; }
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="print-header">
          <h1>Заказ StomaHelp</h1>
          <p>Дата: ${new Date().toLocaleDateString('ru-RU')}</p>
        </div>

        <div class="print-section">
          <h3>Контактные данные</h3>
          <p>Имя: ${name}</p>
          <p>Телефон: ${phone}</p>
          <p>Email: ${email}</p>
          <p>ИНН: ${inn}</p>
          <p>Компания: ${company}</p>
        </div>

        <div class="print-section">
          <h3>Система налогообложения</h3>
          <p>${nalog === 'usn' ? 'УСН (упрощенная система налогообложения)' : 'ОСН (общая система налогообложения)'}</p>
        </div>

        <div class="print-section">
          <p>Адрес доставки: ${delivery_adres != 0 ? delivery_adres : ''}</p>
        </div>

        <div class="print-section">
          <h3>Товары</h3>
          <table class="print-table">
            <thead>
              <tr>
                <th>Наименование</th>
                <th>Кол-во уп.</th>
                <th>Цена за уп.</th>
                <th>Сумма</th>
              </tr>
            </thead>
            <tbody>
              ${products.map(product => `
                <tr>
                  <td>${product.name}</td>
                  <td>${Math.floor(product.count / product.upakovka)}</td>
                  <td>${this.priceFormat(product.price * product.upakovka)} ₽</td>
                  <td>${this.priceFormat(product.price * product.count)} ₽</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>

        <div class="print-section">
          <h3>Итоги</h3>
          <p>Стоимость товаров: ${this.priceFormat(sum)} ₽</p>
          <p>Стоимость доставки: ${this.priceFormat(delivery_price)} ₽</p>
          ${nalog === 'osn' ? `
            <p>Сумма НДС (20%): ${this.priceFormat(sum * 0.2)} ₽</p>
            <p class="print-total">Итого, включая НДС: ${this.priceFormat(sum * 1.2 + delivery_price)} ₽</p>
          ` : `
            <p class="print-total">Итого: ${this.priceFormat(sum + delivery_price)} ₽</p>
          `}
        </div>

        <div class="no-print" style="margin-top: 20px; text-align: center;">
          <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Печать
          </button>
          <button onclick="window.close()" style="padding: 10px 20px; margin-left: 10px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Закрыть
          </button>
        </div>
      </body>
      </html>
    `;

    // Открываем новое окно для печати
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    
    // Даем время на загрузку контента перед печатью
    printWindow.onload = function() {
      printWindow.focus();
      // Автоматически запускаем печать
      printWindow.print();
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.user?.authorized !== prevProps.user?.authorized) {
      const { user } = this.props
      if( user.authorized ) {
        this.setState({
          name: user.fullname,
          phone: user.mobilephone,
          email: user.email,
          inn: user?.inn || ``,
          company: user?.company || ``
        })
      }
    }
  }

  componentDidMount() {
    this.getCart()

    const { user_profile_type } = this.props

    if(user_profile_type == `legal`) {
      this.setState({
        payment: 3
      })
    } else {
      this.setState({
        payment: 2
      })
    }
  }

  render() {

    const { ajax_data, data, favorite, cart, changeFavorite, user_profile_type } = this.props,
    { loaded, products, count, sum, delivery_price, payment, name, phone, email, inn, company, comment, show, modal_text, certificate, nalog } = this.state

    if(ajax_data == null) reutrn (
      <></>
    )

    if(user_profile_type == `legal`) return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <>
              <Breadcrumbs
                items={ajax_data.breadcrumbs}
              />
              <div className={styles.korzina}>
                <Container className={styles.container}>
                  <h1>Оформление заказа</h1>
                  <div className='d-flex flex-column flex-xl-row align-items-start justify-content-between'>
                    <div className={styles.korzina_flex_oform}>
                      <div>
                        <div className={styles.korzina_text}>
                          Курьерская служба интернет-магазина StomaHelp доставит заказ по Нижнему Новгороду и области в нужное время.
                        </div>
                      </div>
                      {loaded ?
                        <>
                          {products.length > 0 ?
                            <Form className={styles.korzina_form}>
                              <div className={styles.korzina_form_title}>Контактные данные</div>
                              <Form.Control
                                name='name'
                                onChange={( e ) => this.setName( e.target.value )}
                                value={name}
                                className={`${styles.korzina_form_input} ${icon_styles.name_input}`} 
                                type="text"
                                placeholder="Ваше имя"
                              />
                              <Form.Control
                                name='phone'
                                as={IMaskInput}
                                mask="+{7} (000) 000-00-00"
                                lazy={true}
                                type="phone"
                                onChange={( e ) => this.setPhone( e.target.value )}
                                value={phone}
                                className={`${styles.korzina_form_input} ${icon_styles.phone_input}`} 
                                placeholder="Ваш телефон"
                                autoComplete="new-password"
                              />
                              <Form.Control 
                                name="inn" 
                                className={`${styles.korzina_form_input} ${icon_styles.inn_input}`} 
                                type="text" 
                                value={inn} 
                                onChange={( e ) => this.change_inn( e.target.value )} 
                                placeholder="ИНН" 
                              />
                              <Form.Control 
                                name="company" 
                                className={`${styles.korzina_form_input} ${icon_styles.company_input}`} 
                                type="text" 
                                value={company} 
                                onChange={( e ) => this.change_company( e.target.value )} 
                                placeholder="Название компании" 
                              />
                              <Form.Control
                                name='email'
                                onChange={( e ) => this.setEmail( e.target.value )}
                                value={email}
                                className={`${styles.korzina_form_input} ${icon_styles.email_input}`} 
                                type="email" 
                                placeholder="Ваше e-mail"
                              />
                              <div className={styles.korzina_form_title}>Выберите систему налогооблажения</div>
                              <div className={styles.korzina_form_checkbox_container_nalog}>
                                <div onClick={() => this.setNalog( `usn` )} className={styles.korzina_form_checkbox}>
                                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                    {nalog == `usn` &&
                                      <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                                    }
                                  </svg>
                                  <div className={styles.korzina_form_checkbox_name}>УСН</div>
                                </div>
                                <div onClick={() => this.setNalog( `osn` )} className={styles.korzina_form_checkbox}>
                                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                    {nalog == `osn` &&
                                      <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                                    }
                                  </svg>
                                  <div className={styles.korzina_form_checkbox_name}>ОСН</div>
                                </div>
                              </div>
                              <DeliveryMethods
                                ajax_data={ajax_data}
                                priceFormat={this.priceFormat}
                                setDelivery={this.setDelivery}
                                delivery_price={delivery_price}
                                cart={cart}
                                sum={sum}
                                payment={payment}
                              />
                              <Form.Control
                                name='comment'
                                onChange={( e ) => this.setComment( e.target.value )}
                                value={comment}
                                className={styles.korzina_form_textarea}
                                as="textarea"
                                rows={5}
                                placeholder="Комментарий к заказу"
                              />
                            </Form>
                          :
                            <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                              <p>Добавьте товары в корзину</p>
                            </div>
                          }
                        </>
                      :
                        <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                          <Spinner animation="grow" variant="dark" />
                        </div>
                      }
                    </div>
                    <div className={styles.korzina_rchast}>
                      <div className={styles.korzina_rchast_plashka}>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className={styles.korzina_rchast_title}>Ваш заказ</div>
                          <div className={styles.korzina_rchast_count}>{count} {this.normalizeCountForm( count, [ 'товар', 'товара', 'товаров' ] )}</div>
                        </div>
                        <div className={styles.korzina_rchast_text}>
                          Доступные способы доставки можно выбрать при оформлении заказа
                        </div>
                        {loaded &&
                          <>
                            <div className={styles.korzina_rchast_sep}></div>
                            {products.length > 0 &&
                              <>
                                <div className={styles.korzina_rchast_products}>
                                  {products.map( ( product, k ) => {
                                    return (
                                      <div className={styles.korzina_list_elm} key={k}>
                                        <div style={{ flex: 1 }} className='d-flex'>
                                          <div className={styles.korzina_list_elm_content_rchast}>
                                            <div className='d-flex align-items-start mb-2 justify-content-between w-100'>
                                              <div className={styles.korzina_list_elm_legal_t1}>{product.name}</div>
                                              <div className={styles.korzina_list_elm_legal_t2}>{this.priceFormat(product.price * product?.upakovka)} ₽/уп.</div>
                                            </div>
                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                              <div>
                                                <div className={styles.korzina_list_elm_legal_t1}>Количество упаковок</div>
                                                <div className={styles.korzina_list_elm_legal_t3}>{Math.floor(product?.count / product?.upakovka)} {this.normalizeCountForm( Math.floor(product?.count / product?.upakovka), [ 'упаковка', 'упаковки', 'упаковок' ] )}</div>
                                              </div>
                                              <div className={styles.korzina_list_elm_btns_elm + ` ms-0`} onClick={() => this.changeCount( product, 0 )}>
                                                <CartIcon />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              </>
                            }
                            <div className={styles.korzina_rchast_sep}></div>
                            {count > 0 &&
                              <>
                                <div className={styles.korzina_rchast_sum_nalog}>
                                  <div>Сумма НДС (включена в полную стоимость):</div>
                                  <div style={{ whiteSpace: `nowrap` }}>
                                    {nalog === 'osn' 
                                      ? this.priceFormat(sum * 0.2) // 20% НДС для ОСН
                                      : '0' // НДС не применяется для УСН
                                    } ₽
                                  </div>
                                </div>
                                <div className={styles.korzina_rchast_sum}>
                                  <div>Итого, включая НДС:</div>
                                  <div>
                                    {nalog === 'osn' 
                                      ? this.priceFormat(sum * 0.2 + ( delivery_price ? sum + delivery_price : sum ) )
                                      : delivery_price ? this.priceFormat( sum + delivery_price ) : this.priceFormat( sum )
                                    } ₽
                                  </div>
                                </div>
                                <div style={{ gap: `10px` }} className='d-flex flex-column align-items-center justify-content-between'>
                                  <Button 
                                    onClick={() => this.sendOrder()} 
                                    className={styles.korzina_rchast_btn + ` w-100`} 
                                    variant='primary'
                                    disabled={this.state.isSubmitting} // Блокируем кнопку во время отправки
                                  >
                                    <div className='text-white'>
                                      {this.state.isSubmitting ? 'Отправка заказа...' : 'Отправить заказ'}
                                    </div>
                                  </Button>
                                  <Button 
                                    onClick={() => this.printOrder()} 
                                    className={styles.korzina_rchast_btn_2 + ` w-100`} 
                                    variant='light'
                                  >
                                    Распечатать
                                  </Button>
                                </div>
                              </>
                            }
                          </>
                        }
                      </div>
                      <div className={styles.korzina_rchast_rekviziti}>
                        <div className={styles.korzina_rchast_rekviziti_top}>
                          <div>Реквизиты для выставления счета</div>
                          <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L5.5 5L10 1" stroke="black" stroke-width="0.75"/>
                          </svg>
                        </div>
                        <div className={styles.korzina_rchast_rekviziti_content}>
                          <div>
                            <div>Название организации</div>
                            <div>Контактное лицо, электронная почта</div>
                            <div>ИНН</div>
                          </div>
                          <div>
                            <div>ИП Ушаков Иван Иванович</div>
                            <div>Ушаков Иван Иванович, info@stomahelp.ru</div>
                            <div>525102075441</div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.korzina_rchast_katalog}>
                        <div className={styles.korzina_rchast_pkonf + ` d-flex align-items-center justify-content-center w-100`}>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                            <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                          </svg>
                          <div>Я ознакомлен и согласен с условиями <a href={ajax_data.pconf_link}>оферты и политики конфиденциальности</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Container>
              </div>
            </>
          }
        </div>
        <Modal centered show={show} onHide={() => this.handleClose()}>
          <Modal.Header closeButton>
            <Modal.Title>{ajax_data.pagetitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal_text}</Modal.Body>
        </Modal>
      </>
    )

    return (
      <>
        <div className='w-100' style={{ flex: 1 }}>
          {ajax_data != null &&
            <>
              <Breadcrumbs
                items={ajax_data.breadcrumbs}
              />
              <div className={styles.korzina}>
                <Container className={styles.container}>
                  <h1>Оформление заказа</h1>
                  <div className='d-flex flex-column flex-xl-row align-items-start justify-content-between'>
                    <div className={styles.korzina_flex_oform}>
                      <div>
                        <div className={styles.korzina_text}>
                          Курьерская служба интернет-магазина StomaHelp доставит заказ по Нижнему Новгороду и области в нужное время.
                        </div>
                      </div>
                      {loaded ?
                        <>
                          {products.length > 0 ?
                            <Form className={styles.korzina_form}>
                              <div className={styles.korzina_form_title}>Контактные данные</div>
                              <Form.Control
                                name='name'
                                onChange={( e ) => this.setName( e.target.value )}
                                value={name}
                                className={`${styles.korzina_form_input} ${icon_styles.name_input}`} 
                                type="text"
                                placeholder="Ваше имя"
                              />
                              <Form.Control
                                name='phone'
                                as={IMaskInput}
                                mask="+{7} (000) 000-00-00"
                                lazy={true}
                                type="phone"
                                onChange={( e ) => this.setPhone( e.target.value )}
                                value={phone}
                                className={`${styles.korzina_form_input} ${icon_styles.phone_input}`} 
                                placeholder="Ваш телефон"
                                autoComplete="new-password"
                              />
                              <Form.Control
                                name='email'
                                onChange={( e ) => this.setEmail( e.target.value )}
                                value={email}
                                className={`${styles.korzina_form_input} ${icon_styles.email_input}`} 
                                type="email" 
                                placeholder="Ваше e-mail"
                              />
                              <DeliveryMethods
                                ajax_data={ajax_data}
                                priceFormat={this.priceFormat}
                                setDelivery={this.setDelivery}
                                delivery_price={delivery_price}
                                cart={cart}
                                sum={sum}
                                payment={payment}
                              />
                              <div className={styles.korzina_form_title}>Способы оплаты</div>
                              <div className={styles.korzina_form_checkbox_container_simple}>
                                {ajax_data.payments.map(( pel, k ) => {
                                  if(pel.id == 7) {
                                    if(certificate) {
                                      return (
                                        <div onClick={() => this.setPayment( pel.id )} key={k} className={styles.korzina_form_checkbox}>
                                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                            {payment == pel.id &&
                                              <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                                            }
                                          </svg>
                                          <div className={styles.korzina_form_checkbox_name}>{pel.name}</div>
                                        </div>
                                      )
                                    } else {
                                      return (
                                        <></>
                                      )
                                    }
                                  }
                                  if(pel.id != 3) return (
                                    <div onClick={() => this.setPayment( pel.id )} key={k} className={styles.korzina_form_checkbox}>
                                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                                        {payment == pel.id &&
                                          <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                                        }
                                      </svg>
                                      <div className={styles.korzina_form_checkbox_name}>{pel.name}</div>
                                    </div>
                                  )
                                })}
                              </div>
                              <Form.Control
                                name='comment'
                                onChange={( e ) => this.setComment( e.target.value )}
                                value={comment}
                                className={styles.korzina_form_textarea}
                                as="textarea"
                                rows={5}
                                placeholder="Комментарий к заказу"
                              />
                            </Form>
                          :
                            <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                              <p>Добавьте товары в корзину</p>
                            </div>
                          }
                        </>
                      :
                        <div style={{ height: `616px` }} className={styles.korzina_list + ` d-flex align-items-center justify-content-center`}>
                          <Spinner animation="grow" variant="dark" />
                        </div>
                      }
                    </div>
                    <div className={styles.korzina_rchast}>
                      <div className={styles.korzina_rchast_plashka}>
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className={styles.korzina_rchast_title}>Ваш заказ</div>
                          <div className={styles.korzina_rchast_count}>{count} {this.normalizeCountForm( count, [ 'товар', 'товара', 'товаров' ] )}</div>
                        </div>
                        <div className={styles.korzina_rchast_text}>
                          Доступные способы доставки можно выбрать при оформлении заказа<br />
                          <b>При заказе от 5 000 бесплатная доставка</b>
                        </div>
                        {loaded &&
                          <>
                            <div className={styles.korzina_rchast_sep}></div>
                            {products.length > 0 &&
                              <>
                                <div className={styles.korzina_rchast_products}>
                                  {products.map( ( product, k ) => {
                                    return (
                                      <div className={styles.korzina_list_elm} key={k}>
                                        <div style={{ flex: 1 }} className='d-flex'>
                                          {product.image != null &&
                                            <a href={product.url}>
                                              <Image alt="ВАШ ЗАКАЗ" className={styles.korzina_list_elm_image + ` d-block`} src={product.image} width="117" height="172" />
                                            </a>
                                          }
                                          <div className={styles.korzina_list_elm_content_rchast}>
                                            <div className='d-flex align-items-center justify-content-between w-100'>
                                              <div className={styles.korzina_list_elm_art_rchast}>Арт. {product.article}</div>
                                              <div className={styles.korzina_list_elm_price_rchast}>{this.priceFormat(product.price)} ₽</div>
                                            </div>
                                            <div className={styles.korzina_list_elm_name_rchast}>{product.name}</div>
                                            <div className={styles.korzina_list_elm_vendor + ` mb-3`}>{product.vendor}</div>
                                            <div style={{ flex: 1 }} className='d-flex flex-column w-100'>
                                              <div className='d-block' style={{ flex: 1 }}></div>
                                              <div className='d-flex align-items-end justify-content-between w-100'>
                                                <div className={styles.korzina_list_elm_btns + ` d-flex`}>
                                                  <div className={styles.korzina_list_elm_btns_elm + ` ms-0`} onClick={() => this.changeCount( product, 0 )}>
                                                    <CartIcon />
                                                  </div>
                                                  <div className={styles.korzina_list_elm_btns_elm} onClick={() => changeFavorite( product.id )}>
                                                    <FavoriteIcon isFavorite={favorite.includes( product.id )} />
                                                  </div>
                                                </div>
                                                <div> </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  })}
                                </div>
                              </>
                            }
                            <div className={styles.korzina_rchast_sep}></div>
                            {count > 0 &&
                              <>
                                <div className={styles.korzina_rchast_sum}>
                                  <div>Итого:</div>
                                  <div>{delivery_price ? this.priceFormat( sum + delivery_price ) : this.priceFormat( sum )} ₽</div>
                                </div>
                                <div className='d-flex flex-column flex-sm-row align-items-center justify-content-between'>
                                  <Button 
                                    onClick={() => this.sendOrder()} 
                                    className={styles.korzina_rchast_btn + ` w-100`} 
                                    variant='primary'
                                    disabled={this.state.isSubmitting} // Блокируем кнопку во время отправки
                                  >
                                    <div className='text-white'>
                                      {this.state.isSubmitting ? 'Отправка заказа...' : 'Подтвердить заказ'}
                                    </div>
                                  </Button>
                                </div>
                              </>
                            }
                          </>
                        }
                      </div>
                      {certificate &&
                        <div className={styles.korzina_rchast_tru}>
                          <div>В корзине есть товары с кодом ТРУ</div>
                          <div className={styles.korzina_rchast_tru_sep}></div>
                          <a href={data.page_data?.link_sertpage}>Подробнее →</a>
                        </div>
                      }
                      <div className={styles.korzina_rchast_katalog}>
                        <div className={styles.korzina_rchast_pkonf + ` d-flex align-items-center justify-content-center w-100`}>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.375" y="0.375" width="16.25" height="16.25" rx="8.125" fill="white" stroke="#1E9FF6" strokeWidth="0.75"/>
                            <rect x="5" y="5" width="7" height="7" rx="3.5" fill="#1E9FF6"/>
                          </svg>
                          <div>Я ознакомлен и согласен с условиями <a href={ajax_data.pconf_link}>оферты и политики конфиденциальности</a></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Container>
              </div>
            </>
          }
        </div>
        <Modal centered show={show} onHide={() => this.handleClose()}>
          <Modal.Header closeButton>
            <Modal.Title>{ajax_data.pagetitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modal_text}</Modal.Body>
        </Modal>
      </>
    )
  }
}

Oformlenie.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  changeFavorite: PropTypes.func,
  favorite: PropTypes.array,
  cart: PropTypes.array,
  addTocart: PropTypes.func,
  user_profile_type: PropTypes.string,
  clearCart: PropTypes.func,
  user: PropTypes.object
}